import React, { useState, useEffect } from "react";
import Editor from "./Components/Editor";
import ExportModal from "./Components/ExportModal";
import SideBar from "./Components/SideBar";

function App() {
  const [exportModal, setExportModal] = useState(false);
  const [showEditor, setShowEditor] = useState(true);
  const [html, setHtml] = useState("");
  const [css, setCss] = useState("");
  const [js, setJs] = useState("");

  const clearAll = () => {
    setHtml("");
    setCss("");
    setJs("");
  };

  const toggleEditor = () => {
    setShowEditor(!showEditor);
  };

  const srcDoc = `<html>\n<head>${css && `\n<style>\n${css}\n</style>\n`} ${js && `\n<script>\n${js}\n</script>\n`}</head>\n<body>\n${html}\n</body>\n</html>`;

  useEffect(() => {
    const htmlLocal = localStorage.getItem("codepen-html");
    const cssLocal = localStorage.getItem("codepen-css");
    const jsLocal = localStorage.getItem("codepen-js");

    setHtml(JSON.parse(htmlLocal) || "");
    setCss(JSON.parse(cssLocal) || "");
    setJs(JSON.parse(jsLocal) || "");
  }, []);

  useEffect(() => {
    localStorage.setItem("codepen-html", JSON.stringify(html));
    localStorage.setItem("codepen-css", JSON.stringify(css));
    localStorage.setItem("codepen-js", JSON.stringify(js));
  }, [html, css, js]);

  return (
    <div className="App">
      <SideBar onClear={clearAll} onToggleEditor={toggleEditor} showEditor={showEditor} onExport={()=>setExportModal(true)}/>
      <div className="screen" style={{ width: "100%" }}>
        {
          <div className={`panel top${showEditor ? "" : "-closed"}`}>
            <Editor
              lang="xml"
              title="HTML"
              value={html}
              onChange={setHtml}
            />
            <Editor
              lang="css"
              title="CSS"
              value={css}
              onChange={setCss}
            />
            <Editor
              lang="javascript"
              title="JS"
              value={js}
              onChange={setJs}
            />
          </div>
        }
        <div className="panel bottom">
          <iframe
            srcDoc={srcDoc}
            title="output"
            sandbox="allow-scripts"
            width="100%"
            height="100%"
          />
        </div>
      </div>
      <ExportModal isOpen={exportModal} onClose={()=>setExportModal(false)} exportContent={srcDoc}/>
    </div>
  );
}

export default App;
